import WarningIcon from '@mui/icons-material/WarningRounded';

export default WarningIcon;
